import { BoardSize } from '@pindd/types'

export const fiveMmBoards: BoardSize[] = [
  {
    id: '5mm-small',
    name: '小号 29×29',
    width: 29,
    height: 29,
    beadSize: '5mm',
    physicalWidth: 145,
    physicalHeight: 145,
  },
  {
    id: '5mm-medium',
    name: '中号 58×58',
    width: 58,
    height: 58,
    beadSize: '5mm',
    physicalWidth: 290,
    physicalHeight: 290,
  },
  {
    id: '5mm-large',
    name: '大号 116×116',
    width: 116,
    height: 116,
    beadSize: '5mm',
    physicalWidth: 580,
    physicalHeight: 580,
  },
]
